// import React, { useEffect, useState } from 'react'
// import { useDispatch, useSelector } from 'react-redux'
// import { useNavigate, useParams } from 'react-router-dom'

// import { articleCardClick } from '../../components/Analytics/Analytics'
import { Feedback } from '../../components/Feedback/Feedback'
import { TableLayout } from '../../components/TableLayout/TableLayout'
import { Layout } from '../../components/UI/Layout/Layout'
import { NewBanner } from '../../components/UI/NewBanner/NewBanner'
import { articleCardsNew } from '../../consts/articlesCardsNew'

export const Articles = () => {
  return (
    <Layout>
      <TableLayout
        items={articleCardsNew}
        title='Все статьи'
        category='/article/'
        id='#articles'
      />
      <NewBanner pageType='main' />
      <Feedback />
    </Layout>
  )
}
